import CaseFirstViewWhite from 'components/cases/common/CasesFirstViewWhite/'
import OverView from 'components/cases/common/Overview/'
import Interview from 'components/cases/heart-one/Interview/Interview'
import MobileAppDevelopment from 'components/services/common/MobileAppDevelopment'
import CaseStudyNew from '../../home/CaseStudy/CaseStudyNew'
import {
  firstViewItemWhite,
  overviewItem,
  overviewTitle,
  issueSolutionItems,
  caseCTAItem,
  caseDownloadCTAItem,
} from './HeartOneItems'
import CaseCTA from 'components/cases/common/CaseCTA'
import CaseDownloadCTA from 'components/cases/common/CaseDownloadCTA'
import FooterCTA from 'components/common/FooterCTA'
import styles from './HeartOne.module.scss'

const HeartOne = (): JSX.Element => {
  return (
    <>
      <CaseFirstViewWhite firstViewItemWhite={firstViewItemWhite} />
      <OverView overviewItem={overviewItem} issueSolutionItems={issueSolutionItems} overviewTitle={overviewTitle} />
      <Interview />
      <CaseCTA {...caseCTAItem} />
      <CaseDownloadCTA {...caseDownloadCTAItem} />
      <FooterCTA />
      <div className={styles.mobileAppWrapper}>
        <MobileAppDevelopment />
      </div>
      <div className={styles.line}>
        <CaseStudyNew />
      </div>
    </>
  )
}

export default HeartOne
